import openMobileMenu from "./modules/open-mobile-menu";
import homepageHero from "./modules/homepage-hero";
import setHeaderColor from "./modules/set-header-color";
import sendNewsletterForm from "./modules/send-newsletter-form.js";
import openNewsletterModal from "./modules/open-newsletter-modal.js";

window.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector("header")) {
    openMobileMenu();
    setHeaderColor();
  }

  if (document.querySelector(".homepage-hero")) {
    homepageHero();
  }

  if (document.querySelector("form.newsletter-subscribe-form")) {
    openNewsletterModal();
    sendNewsletterForm();
  }
});
